import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ec40103c")

_pushScopeId("data-v-ec40103c")
const _hoisted_1 = { class: "p-mb-4 p-d-flex p-justify-between p-ai-end" }
const _hoisted_2 = { class: "log-info p-mr-2" }
const _hoisted_3 = { class: "log-warn p-mr-2" }
const _hoisted_4 = { class: "log-error" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "log-info"
}
const _hoisted_12 = {
  key: 1,
  class: "log-warn"
}
const _hoisted_13 = {
  key: 2,
  class: "log-error"
}
const _hoisted_14 = {
  key: 0,
  class: "log-info"
}
const _hoisted_15 = {
  key: 1,
  class: "log-warn"
}
const _hoisted_16 = {
  key: 2,
  class: "log-error"
}
const _hoisted_17 = {
  key: 0,
  class: "p-mt-4"
}
const _hoisted_18 = { class: "p-mb-2" }
const _hoisted_19 = {
  key: 0,
  class: "log-info"
}
const _hoisted_20 = {
  key: 1,
  class: "log-warn"
}
const _hoisted_21 = {
  key: 2,
  class: "log-error"
}
const _hoisted_22 = {
  key: 1,
  class: "log-error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: "p-button p-button-link",
      label: _ctx.$t('experiment.log.show_logs'),
      onClick: _ctx.toggleDialog
    }, null, 8, ["label", "onClick"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog = $event)),
      modal: true,
      breakpoints: { '1400px': '90vw' },
      style: { width: '70vw' },
      header: _ctx.$t('experiment.log.dialog.header')
    }, {
      default: _withId(() => [
        (!!_ctx.logs)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_2, _toDisplayString(_ctx.logCount.info) + " " + _toDisplayString(_ctx.$t("experiment.log.type.info")), 1),
                  _createVNode("span", _hoisted_3, _toDisplayString(_ctx.logCount.warn) + " " + _toDisplayString(_ctx.$t("experiment.log.type.warn")), 1),
                  _createVNode("span", _hoisted_4, _toDisplayString(_ctx.logCount.error) + " " + _toDisplayString(_ctx.$t("experiment.log.type.error")), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_Dropdown, {
                    options: _ctx.logFilter,
                    modelValue: _ctx.selectedLogFilter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedLogFilter = $event)),
                    style: {"min-width":"10rem"}
                  }, {
                    value: _withId(({ value: { key } }) => [
                      (key === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("experiment.log.filter.info")), 1))
                        : _createCommentVNode("", true),
                      (key === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("experiment.log.filter.warn")), 1))
                        : _createCommentVNode("", true),
                      (key === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("experiment.log.filter.error")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    option: _withId(({ option: { key } }) => [
                      (key === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("experiment.log.filter.info")), 1))
                        : _createCommentVNode("", true),
                      (key === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("experiment.log.filter.warn")), 1))
                        : _createCommentVNode("", true),
                      (key === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("experiment.log.filter.error")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue"])
                ])
              ]),
              _createVNode(_component_DataTable, {
                value: _ctx.filteredLog,
                selectionMode: "single",
                selection: _ctx.selectedLog,
                "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedLog = $event)),
                scrollable: true,
                scrollHeight: "60vh",
                responsiveLayout: "scroll"
              }, {
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    style: {"min-width":"18rem","max-width":"18rem"},
                    field: "timestamp",
                    header: _ctx.$t('experiment.log.table.header.time')
                  }, {
                    body: _withId(({ data: { timestamp } }) => [
                      _createTextVNode(_toDisplayString(_ctx.$moment(timestamp).format("LL LTS")), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    style: {"min-width":"10rem","max-width":"10rem"},
                    field: "level",
                    header: _ctx.$t('experiment.log.table.header.type')
                  }, {
                    body: _withId(({ data: { level } }) => [
                      (level === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("experiment.log.type.info")), 1))
                        : _createCommentVNode("", true),
                      (level === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("experiment.log.type.warn")), 1))
                        : _createCommentVNode("", true),
                      (level === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("experiment.log.type.error")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "message",
                    header: _ctx.$t('experiment.log.table.header.message'),
                    style: {"min-width":"30em"}
                  }, {
                    body: _withId(({
              data: {
                level,
                messages: { title },
              },
            }) => [
                      (level === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(title), 1))
                        : _createCommentVNode("", true),
                      (level === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(title), 1))
                        : _createCommentVNode("", true),
                      (level === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(title), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["header"])
                ]),
                _: 1
              }, 8, ["value", "selection"]),
              (_ctx.selectedLog)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      (_ctx.selectedLog.level === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.selectedLog.messages.title), 1))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLog.level === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(_ctx.selectedLog.messages.title), 1))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLog.level === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(_ctx.selectedLog.messages.title), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedLog.messages.rest, (message, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        style: {"word-break":"break-word"}
                      }, _toDisplayString(message), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("experiment.log.could_not_show")), 1))
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
})